export const profileVector = [
  {
    id: 1,
    classname: "dots-images simple-list",
  },
  {
    id: 2,
    classname: "dot-small bg-info dot-1",
  },
  {
   id: 3,
   classname: "dot-medium bg-primary dot-2",
 },
 {
   id: 4,
   classname: "dot-medium bg-info dot-3",
 },
 {
   id: 5,
   classname: "semi-medium bg-primary dot-4",
 },
 {
   id: 6,
   classname: "dot-small bg-info dot-5",
 },
 {
   id: 7,
   classname: "dot-big bg-info dot-6",
 },
 {
   id: 8,
   classname: "dot-small bg-primary dot-7",
 },
 {
   id: 9,
   classname: "semi-medium bg-primary dot-8",
 },
 {
   id: 10,
   classname: "dot-big bg-info dot-9",
 },

];
export const profileImage =[
  {
    id:1,
    img:"ribbon1.png"
  },
  {
    id:2,
    img:"ribbon3.png"
  },
  {
    id:3,
    img:"ribbon4.png"
  },
  {
    id:4,
    img:"ribbon5.png"
  },
  {
    id:5,
    img:"ribbon6.png"
  },
  {
    id:6,
    img:"ribbon7.png"
  },

]
